import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import RecentUserTable from "../../../Components/Table/RecentUserTable";
import { Link } from "react-router-dom";
import { GetRecentUser } from "../../../APIs/Function/User/GetRecentUser";
import { GetPremiumUser } from "../../../APIs/Function/User/GetPremiumUser";
import { GetAnalyticsData } from "../../../APIs/Function/User/GetAnalytics";
import Loader from "../../../Components/Loader/Loader";

const Dashboard = () => {
  const [recentUserData, setRecentUserData] = useState([]);
  const [analyticsData, setAnalyticsData] = useState([]);
  const [premiumUserData, setPremiumUserData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleRecentUser = async () => {
    try {
      setLoading(true);
      let res = await GetRecentUser();
      setRecentUserData(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handlePremiumUser = async () => {
    try {
      setLoading(true);
      let res = await GetPremiumUser();
      setPremiumUserData(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleAnalytics = async () => {
    try {
      setLoading(true);
      let res = await GetAnalyticsData();
      setAnalyticsData(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    handleRecentUser();
    handlePremiumUser();
    handleAnalytics();
  }, []);
console.log(recentUserData)
  return (
    <>
      {" "}
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <Loader />
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              width: "100%",
              p: 2,
              boxSizing: "border-box",
            }}
          >
            {/* uppper box */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  border: "1px solid #DDDDDD",
                  padding: "5px",
                  width: "18%",
                  height: "90px",
                  boxSizing: "border-box",
                  textAlign: "center",
                  p: 2,
                }}
              >
                <Box>
                  <Typography
                    noWrap
                    sx={{
                      fontFamily: "Open Sans",
                      textAlign: "center",
                      fontSize: { xs: "12px", md: "16px" },
                      fontWeight: "400",
                      lineHeight: "14px",
                      textOverflow: "ellipsis",
                      overflow: "auto",
                      "&:hover": {
                        overflow: "visible",
                      },
                    }}
                  >
                    Total Users
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    textAlign: "center",
                    fontSize: { xs: "16px", md: "24px" },
                    fontWeight: "600",
                    lineHeight: "24px",
                    mt: "10px",
                  }}
                >
                  {analyticsData?.total_users - 1 || 0}
                </Typography>
              </Box>
              <Box
                sx={{
                  border: "1px solid #DDDDDD",
                  padding: "5px",
                  width: "18%",
                  boxSizing: "border-box",
                  p: 2,
                }}
              >
                <Box>
                  <Typography
                    noWrap
                    sx={{
                      fontFamily: "Open Sans",
                      textAlign: "center",
                      fontSize: { xs: "12px", md: "16px" },
                      fontWeight: "400",
                      lineHeight: "14px",
                      textOverflow: "ellipsis",
                      overflow: "auto",
                      maxWidth: "100%",

                      "&:hover": {
                        overflow: "visible",
                      },
                    }}
                  >
                    Total Products
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    textAlign: "center",
                    fontSize: { xs: "16px", md: "24px" },
                    fontWeight: "600",
                    lineHeight: "24px",
                    mt: "10px",
                  }}
                >
                  {analyticsData?.total_products}
                </Typography>
              </Box>
              <Box
                sx={{
                  border: "1px solid #DDDDDD",
                  padding: "5px",
                  height: "90px",
                  boxSizing: "border-box",
                  p: 2,
                }}
              >
                <Box>
                  <Typography
                    noWrap
                    sx={{
                      fontFamily: "Open Sans",
                      textAlign: "center",
                      fontSize: { xs: "12px", md: "16px" },
                      fontWeight: "400",
                      lineHeight: "14px",
                      textOverflow: "ellipsis",
                      overflow: "auto",
                      maxWidth: "100%",

                      "&:hover": {
                        overflow: "visible",
                      },
                    }}
                  >
                    Total Premium Users
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    textAlign: "center",
                    fontSize: { xs: "16px", md: "24px" },
                    fontWeight: "600",
                    lineHeight: "24px",
                    mt: "10px",
                  }}
                >
                  {analyticsData?.total_premium_users}
                </Typography>
              </Box>
              <Box
                sx={{
                  border: "1px solid #DDDDDD",
                  padding: "5px",
                  width: "18%",
                  height: "90px",
                  boxSizing: "border-box",
                  p: 2,
                }}
              >
                <Box>
                  <Typography
                    noWrap
                    sx={{
                      fontFamily: "Open Sans",
                      textAlign: "center",
                      fontSize: { xs: "12px", md: "16px" },
                      fontWeight: "400",
                      lineHeight: "14px",
                      textOverflow: "ellipsis",
                      overflow: "auto",
                      maxWidth: "100%",

                      "&:hover": {
                        overflow: "visible",
                      },
                    }}
                  >
                    Total Free Users
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    textAlign: "center",
                    fontSize: { xs: "16px", md: "24px" },
                    fontWeight: "600",
                    lineHeight: "24px",
                    mt: "10px",
                  }}
                >
                  {analyticsData?.total_free_users}
                </Typography>
              </Box>{" "}
              <Box
                sx={{
                  border: "1px solid #DDDDDD",
                  padding: "5px",
                  width: "18%",
                  height: "90px",
                  boxSizing: "border-box",
                  p: 2,
                }}
              >
                <Box>
                  <Typography
                    noWrap
                    sx={{
                      fontFamily: "Open Sans",
                      textAlign: "center",
                      fontSize: { xs: "12px", md: "16px" },
                      fontWeight: "400",
                      lineHeight: "14px",
                      textOverflow: "ellipsis",
                      overflow: "auto",
                      "&:hover": {
                        overflow: "visible",
                      },
                    }}
                  >
                    Total Revenue
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    textAlign: "center",
                    fontSize: { xs: "16px", md: "24px" },
                    fontWeight: "600",
                    lineHeight: "24px",
                    mt: "10px",
                  }}
                >
                  ${analyticsData?.total_revenue}
                </Typography>
              </Box>
            </Box>
            {/* lowerbox */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
                m: "auto",
                mt: "30px",
                flexWrap: "wrap",
              }}
            >
              <Box
                sx={{
                  border: "1px solid #DDDDDD",
                  width: { xs: "90%", md: "90%", lg: "49%" },
                  height: "75vh",
                  p: "10px",
                  boxSizing: "border-box",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: "500",
                      lineHeight: "16px",
                    }}
                  >
                    Recent Users
                  </Typography>
                  <Link
                    style={{ textDecoration: "none", color: "black" }}
                    to={"/users"}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontSize: "16px",
                        fontWeight: "600",
                        lineHeight: "16px",
                      }}
                    >
                      View All
                    </Typography>
                  </Link>
                </Box>
                {/* table 1 */}
                <RecentUserTable loading={loading} data={recentUserData} />
              </Box>
              <Box
                sx={{
                  border: "1px solid #DDDDDD",
                  width: { xs: "90%", md: "90%", lg: "49%" },
                  height: "75vh",
                  p: "10px",
                  boxSizing: "border-box",
                  mt: { sm: "40px", md: "0px" },
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: "500",
                      lineHeight: "16px",
                    }}
                  >
                    New Premium Users
                  </Typography>
                  <Link
                    style={{ textDecoration: "none", color: "black" }}
                    to={"/Premiumusers"}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontSize: "16px",
                        fontWeight: "600",
                        lineHeight: "16px",
                      }}
                    >
                      View All
                    </Typography>
                  </Link>
                </Box>
                <RecentUserTable loading={loading} data={premiumUserData} />
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Dashboard;
